import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

type YearSelectProps = {
  years: (number | undefined)[];
  defaultValue: number | 'all';
  onChange: (value: number | 'all') => void;
};

const YearSelect = ({ years, defaultValue, onChange }: YearSelectProps) => {
  const { t } = useTranslation();
  return (
    <Select defaultValue={defaultValue} onChange={(value) => onChange(value as number | 'all')}>
      <Select.Option value="all">{t('project-detail.all')}</Select.Option>
      {years.map((year, index) => (
        <Select.Option key={`year-${index}`} value={year}>
          {year}
        </Select.Option>
      ))}
    </Select>
  );
};

export default YearSelect;
